function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "currentColor"
}, /*#__PURE__*/React.createElement("path", {
  d: "M17.7,33.5c-9.1,0-16.5-7.4-16.5-16.5s7.4-16.5,16.5-16.5v2.7c-7.6,0-13.8,6.2-13.8,13.8s6.2,13.8,13.8,13.8V33.5z"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "rotate",
  from: "0 17.7 17",
  to: "360 17.7 17",
  dur: "3s",
  repeatCount: "indefinite",
  keySplines: "0.25 0.1 0.25 1",
  keyTimes: "0;1",
  calcMode: "spline"
})), /*#__PURE__*/React.createElement("path", {
  d: "M17.7,30.8v-2.7c6.2,0,11.2-5,11.2-11.2s-5-11.2-11.2-11.2v-2.7c7.6,0,13.8,6.2,13.8,13.8S24.7,30.8 17.7,30.8z"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "rotate",
  from: "0 17.7 17",
  to: "720 17.7 17",
  dur: "3s",
  repeatCount: "indefinite",
  keySplines: "0.25 0.1 0.25 1",
  keyTimes: "0;1",
  calcMode: "spline"
})), /*#__PURE__*/React.createElement("path", {
  d: "M17.7,28.2c-6.2,0-11.2-5-11.2-11.2s5-11.2,11.2-11.2v2.7c-4.7,0-8.5,3.8-8.5,8.5s3.8,8.5,8.5,8.5V28.2z"
}, /*#__PURE__*/React.createElement("animateTransform", {
  attributeName: "transform",
  type: "rotate",
  from: "0 17.7 17",
  to: "1080 17.7 17",
  dur: "3s",
  repeatCount: "indefinite",
  keySplines: "0.25 0.1 0.25 1",
  keyTimes: "0;1",
  calcMode: "spline"
})));

function SvgLoader(props, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 34 34",
    enableBackground: "new 0 0 34 34",
    ref: svgRef
  }, props), _ref);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLoader);
export default __webpack_public_path__ + "loader.0fce2ff95765c41af35fbdf85dcd050a.svg";
export { ForwardRef as ReactComponent };